import Vue from 'vue';
import moment from 'moment'
import * as Sentry from '@sentry/browser';
export default {
  namespaced: true,
  state: {
    assessment:null,
    currentAnswers:null,
    assessmentmeasure:null,
    journeyplan:null,
    measureIntrosDisplayed : {},
    sectionIntrosDisplayed : {},
    phaseIntrosDisplayed : {},
    currentQuestionIndex: 0,
    validationState:null,
    answerBuffer: {},
    answerBufferInFlight: {},
    answersSaving:false,
    auditLogBuffer: [],
    auditLogInFlight: [],
    auditLogSaving:false
  },
  mutations: {
    setAssessment(state,assessment){
      state.assessment=assessment;
      if(!assessment){
        state.measureIntrosDisplayed={};
        state.sectionIntrosDisplayed={};
        state.phaseIntrosDisplayed={};
      }
    },
    setPerson(state, person){
      state.assessment.person=person;
    },
    setCurrentState(state, currentState){
      state.assessment.current_state=currentState;
    },
    saveProfilePicture(state,file){
      state.assessment.profilepic=file;
    },
    hidePicture(state,hide_picture){
      Vue.set(state.assessment.person,'hide_picture',hide_picture);
    },
    setCurrentMeasureEmpty(state, data){
      state.assessment.assessmentjourneyphases=data.assessment.assessmentjourneyphases;
      state.assessment.self_completed_at=data.assessment.self_completed_at;
    },
    setCurrentMeasure(state, data){
      if(!data){
        state.journeyplan=null;
        state.assessmentmeasure=null;
        state.currentQuestionIndex=0;
        return;
      }
      state.journeyplan=data.journeyplan;
      state.assessmentmeasure=data.assessmentmeasure;
      state.assessment.assessmentjourneyphases=data.assessment.assessmentjourneyphases;
      state.assessment.self_completed_at=data.assessment.self_completed_at;
      //Merge if any saved in local answers in answerbuffer
      const buffer={...state.answerBuffer,...state.answerBufferInFlight};
      const answers=data.answers;
      for (let journeyresponseid of Object.keys(buffer)){
        const bufferResponse=buffer[journeyresponseid];
        const newResponse=answers[journeyresponseid];
        if(newResponse && newResponse.updated_at < bufferResponse.updated_at){
          answers[journeyresponseid]=JSON.parse(JSON.stringify(bufferResponse));
        }
      }
      state.currentAnswers=answers;

      //Determine current position
      const getEarliestIncomplete = (journeyresponses)=>{
        let i=0;
        for(let r of journeyresponses){
          const answer=state.currentAnswers[r.journeyresponseid];
          if(!answer || !answer.complete){
            return i;
          }
          i++;
        }
        return i-1;
      };
      if(state.journeyplan.journeyresponses){
        state.currentQuestionIndex=getEarliestIncomplete(state.journeyplan.journeyresponses);
      }
    },
    setPhaseIntroAsDisplayed(state,journeyphaseid){
      Vue.set(state.phaseIntrosDisplayed,journeyphaseid,true);
    },
    setMeasureIntroAsDisplayed(state,journeyphaseid){
      Vue.set(state.measureIntrosDisplayed,journeyphaseid,true);
    },
    setSectionIntroDisplayed(state,measuresectionid){
      Vue.set(state.sectionIntrosDisplayed,measuresectionid,true);
    },
    incrementCurrentQuestion(state){
      if(state.currentQuestionIndex<state.journeyplan.journeyresponses.length)
        state.currentQuestionIndex++;
    },
    decrementCurrentQuestion(state){
      if(state.currentQuestionIndex>0)
        state.currentQuestionIndex--;
    },
    saveAnswer(state,answer){
      Vue.set(state.currentAnswers,answer.journeyresponseid,answer);
    },
    addAnswerToBuffer(state,answer){ //TODO - after persistence check dates and keep newest.
      answer.updated_at=moment.utc().format('X');
      Vue.set(state.answerBuffer,answer.journeyresponseid,answer);
    },
    clearAnswerBuffer(state){
      state.answerBuffer={};
    },
    convertAnswerBufferToInFlight(state){
       const temp=JSON.parse(JSON.stringify(state.answerBuffer));
       state.answerBuffer={};
       state.answerBufferInFlight={
         ...state.answerBufferInFlight,
         ...temp
       };
    },
    clearInFlightBuffer(state){
      state.answerBufferInFlight={};
    },
    setAnswersSaving(state,saving){
      state.answersSaving=saving;
    },
    setValidationState(state,validation){
      state.validationState=validation;
    },
    setAssessmentmeasure(state,data){
      state.assessmentmeasure=data;
    },
    setRtos(state,data){
      state.assessment.rtos=data;
    },
    updateCustomData(state,data){
      state.assessmentmeasure.custom=data;
    },
    addToAuditLogBuffer(state,data){
      state.auditLogBuffer.push(data);
    },
    clearAuditLogBuffer(state){
      state.auditLogBuffer=[];
    },
    convertAuditLogBufferToInFlight(state){
      const temp=JSON.parse(JSON.stringify(state.auditLogBuffer));
      state.auditLogBuffer=[];
      state.auditLogInFlight=state.auditLogInFlight.concat(temp);
    },
    clearInFlightAuditLogBuffer(state){
      state.auditLogInFlight=[];
    },
    setAuditLogSaving(state,saving){
      state.auditLogSaving=saving;
    },
  },
  actions: {
    loadFullyAndBlock({dispatch, commit}, assessmentid){
       commit('setGlobalLoading',true, {root:true});
       return dispatch('loadFully',assessmentid).then(()=>{
         commit('setGlobalLoading',false, {root:true});
       }).catch(()=>{
         commit('setGlobalLoading',false, {root:true});
       });
    },
    loadFully({dispatch}, assessmentid){
      return Promise.all([
        dispatch('assessment/load', assessmentid, {root:true}).then(()=>{
          return Promise.all([
            dispatch('loadCurrentMeasure'),
            dispatch('journey/loadForAssessment', assessmentid,  {root:true})
          ]);
        })
      ]);
    },
    load({commit, dispatch}, assessmentid){
      return this.$http.get('/assessments/'+assessmentid).then((response)=>{
        const assessment=response.data.data;
        commit('setAssessment',assessment);
        commit('auth/setMaskedMobile',assessment.person.masked_mobile,{root:true});
        Sentry.configureScope(function(scope) {
          scope.setUser(assessment);
        });
        return dispatch('language/setFrameworkToAssessmentLocale',assessment,{root:true});
      });
    },
    updateCurrentState({commit, state},currentState){
      commit('setCurrentState',currentState);
      return this.$http.patch('/assessments/'+state.assessment.assessmentid+'/state',{state:currentState}).then(()=>{});
    },
    saveProfilePicture({commit,state},{key,hide_picture}){
      return this.$http.patch('/assessments/'+state.assessment.assessmentid+'/profilepic',{url:key,hide_picture}).then((response)=>{
        commit('saveProfilePicture',response.data.file);
        commit('hidePicture',hide_picture);
        return response.data.file;
      });
    },
    updateAssessmentLanguage({commit,state,dispatch},languageid){
      return this.$http.patch('/assessments/'+state.assessment.assessmentid+'/language',{languageid}).then((response)=>{
        const assessment=response.data.data;
        commit('setAssessment',assessment);
        return dispatch('language/setFrameworkToAssessmentLocale',assessment,{root:true}).then(()=>{
          return  dispatch('assessment/loadFully',assessment.assessmentid,{root:true});
        });
      });
    },
    loadCurrentMeasure({state, commit}){
      return this.$http.get('/assessments/'+state.assessment.assessmentid+'/currentmeasure').then((response)=>{
        const data=response.data.data;
        if(response.data.state === 'complete'){
          console.warn("No next measures found...");
          commit('setCurrentMeasure',null);
          commit('setCurrentMeasureEmpty',response.data);
        }else{
          commit('setCurrentMeasure',data);
          commit('textassets/addTextassets',data.textassets,{root:true});
        }
        return data;
      });
    },
    setPhaseIntroDisplayed({commit},journeyphaseid){
      commit('setPhaseIntroAsDisplayed',journeyphaseid);
    },
    setMeasureIntroDisplayed({commit},journeyphaseid){
      commit('setMeasureIntroAsDisplayed',journeyphaseid);
    },
    setSectionIntroDisplayed({commit},measuresectionid){
      commit('setSectionIntroDisplayed',measuresectionid);
    },
    nextQuestion({commit}){
      commit('setValidationState',null);
      commit('incrementCurrentQuestion');
    },
    previousQuestion({commit}){
      commit('setValidationState',null);
      commit('decrementCurrentQuestion');
    },
    saveAnswer({commit,state},answer){
      const current=state.currentAnswers[answer.journeyresponseid];
      if(JSON.stringify(current)!==JSON.stringify(answer)){ //Used to be JSON.stringify(current.answers)===JSON.stringify(answer.answers)
        commit('saveAnswer',answer);
        commit('addAnswerToBuffer',answer);
      }else{
        commit('saveAnswer',answer);
      }
    },
    saveAuditLogEntry({commit},data){
      commit('addToAuditLogBuffer',data);
    },
    currentAssessmentmeasureStarted({commit,state}){
      return this.$http.post('/assessmentmeasures/'+state.assessmentmeasure.assessmentmeasureid+'/started',{}).then((response)=>{
        commit('setAssessmentmeasure',response.data.data);
      });
    },
    currentAssessmentmeasureComplete({commit,state,dispatch}){
      commit('setValidationState',null);
      const prevJourneyplanid=state.assessmentmeasure.journeyplanid;
      return dispatch('saveAnswerBuffer',true).then(()=>{
         return this.$http.post('/assessmentmeasures/'+state.assessmentmeasure.assessmentmeasureid+'/complete',{}).then((response)=>{
           commit('setAssessmentmeasure',response.data.data);
         }).then(()=>{
           return dispatch('getRtos');
         }).then(()=>{
           return dispatch('assets/removeForJourneyplan',prevJourneyplanid,{root:true});
         });
      });
    },
    validationFailed({commit},{message}){
      commit('setValidationState',{message});
    },
    clearValidation({commit}){
      commit('setValidationState',null);
    },
    saveAnswerBuffer({commit, state, dispatch},force=false){
      return new Promise((resolve,reject)=>{
        if(!state.assessment){
          resolve();
          return;
        }

        if(state.answersSaving && !force){
          resolve();
          return;
        }
        const inFlightEmpty=Object.keys(state.answerBufferInFlight).length===0;
        const bufferEmpty=Object.keys(state.answerBuffer).length===0;
        if(inFlightEmpty && bufferEmpty){
          resolve();
          return;
        }
        commit('setAnswersSaving',true);
        commit('convertAnswerBufferToInFlight');

        this.$http.post('/assessments/'+state.assessment.assessmentid+'/answers',{answers:state.answerBufferInFlight}).then(()=>{
          commit('clearInFlightBuffer');
          commit('setAnswersSaving',false);
          resolve();
        }).catch((err)=>{
          console.error("Error saving answers")
          commit('setAnswersSaving',false);
          reject(err)
        });

        setTimeout(()=>{
          dispatch('assets/cacheRelevantAssets',null,{root:true});
        },50);
      });
    },
    saveAuditLogBuffer({commit, state},force=false){
      return new Promise((resolve,reject)=>{
        if(!state.assessment){
          resolve();
          return;
        }

        if(state.auditLogSaving && !force){
          resolve();
          return;
        }

        const inFlightEmpty=state.auditLogInFlight.length===0;
        const bufferEmpty=state.auditLogBuffer.length===0;
        if(inFlightEmpty && bufferEmpty){
          resolve();
          return;
        }
        commit('setAuditLogSaving',true);
        commit('convertAuditLogBufferToInFlight');
        this.$http.post('/assessments/'+state.assessment.assessmentid+'/auditlog',{data:state.auditLogInFlight}).then(()=>{
          commit('clearInFlightAuditLogBuffer');
          commit('setAuditLogSaving',false);
          resolve();
        }).catch((err)=>{
          commit('setAuditLogSaving',false);
          reject(err)
        });
      });
    },
    getRtos({commit,state}){
      return this.$http.get('/assessments/'+state.assessment.assessmentid+'/rtos',{}).then((response)=>{
        commit('setRtos',response.data.data);
      });
    },
    saveCustomData({commit,state},data){
      return this.$http.post('/assessmentmeasures/'+state.assessmentmeasure.assessmentmeasureid+'/custom',{data}).then(()=>{
         commit('updateCustomData',data);
      });
    }
  },
  getters: {
    assessment(state){
      return state.assessment;
    },
    currentMeasureIsAtEnd(state){
       return state.currentQuestionIndex >= state.journeyplan.journeyresponses.length - 1;
    },
    isCurrentMeasureFirstInPhase(state, getters, rootState){
      if(!state.journeyplan || !rootState.journey.journey){
        return false;
      }
      for(let phase of rootState.journey.journey.journeyphases){
        if(phase.journeyplan[0].journeyplanid===state.journeyplan.journeyplanid){
          return true;
        }
      }
      return false;
    },
    isCurrentPhaseFirstInJourney(state, getters, rootState){
      if(!state.journeyplan || !rootState.journey.journey){
        return false;
      }
      return state.journeyplan.journeyphaseid===rootState.journey.journey.journeyphases[0].journeyphaseid;
    },
    minutesPassed(state,getters,rootState){
      if(!state.assessment || !state.assessment.assessmentjourneyphases || !rootState.journey.journey){
        return 0;
      }
      let current=0;

      for(let phase of state.assessment.assessmentjourneyphases){
        let journeyphase=rootState.journey.journey.journeyphases.find((jp)=>jp.journeyphaseid===phase.journeyphaseid);
        for(let measure of phase.assessmentmeasures){
          if(measure.completed_at && journeyphase){
            let jMeas=journeyphase.journeyplan.find((jp)=>jp.journeyplanid===measure.journeyplanid);
            if(jMeas){
              current+=jMeas.measure.time_estimation;
            }
          }
        }
      }

      if(!state.journeyplan || state.currentQuestionIndex===undefined){
        return current;
      }

      const avgTimePerQuestion=(state.journeyplan.measure.time_estimation)/(state.journeyplan.journeyresponses.length || 1);
      const currentMeasureTime = (state.currentQuestionIndex) * avgTimePerQuestion;

      return current+currentMeasureTime;
    },
    minutesRemaining(state,getters,rootState,rootGetters){
      return Math.ceil(rootGetters['journey/journeyTotalMinutes'] - getters['minutesPassed']);
    },
    allPhasesComplete(state){
      if(!state.assessment || !state.assessment.assessmentjourneyphases){
        return false;
      }
      return state.assessment.assessmentjourneyphases.filter((phase)=>!phase.completed_at).length===0;
    },
    rtosByCategory(state,getters,rootState){
       const result={};
       for(let cat of rootState.journey.journey.journeyrtocategories){
         const obj={
           rtos:[],
           category_textassetid:cat.category_textassetid,
           journeyrtocategoryid:cat.journeyrtocategoryid
         };
         for(let rto of state.assessment.rtos){
           if(rto.journeyrtocategoryid===cat.journeyrtocategoryid){
             obj.rtos.push(rto);
           }
         }

         if(obj.rtos.length>0){
           result[cat.journeyrtocategoryid]=obj;
         }
       }
       return result;
    }
  }
}
